import { gql } from '@apollo/client'

export const personaUpsertMany = gql`
  mutation PersonaUpsertMany($personas: [PersonaInput]!) {
    personaUpsertMany(personas: $personas)
  }
`
